import PropTypes from 'prop-types';

const TaskAssigneesPropType = PropTypes.arrayOf(
  PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    primary: PropTypes.bool.isRequired,
    userId: PropTypes.string.isRequired,
  }),
);

const TaskItemPropType = PropTypes.shape({
  constituents: PropTypes.arrayOf(
    PropTypes.shape({
      constituentId: PropTypes.string.isRequired,
      displayName: PropTypes.string.isRequired,
    }),
  ),
  created: PropTypes.string.isRequired,
  developers: TaskAssigneesPropType,
  dueDate: PropTypes.string,
  isCompleted: PropTypes.bool.isRequired,
  taskId: PropTypes.string.isRequired,
  taskNotes: PropTypes.string,
  taskTitle: PropTypes.string.isRequired,
  updated: PropTypes.string.isRequired,
});

export default TaskItemPropType;
